import React from 'react';

import * as S from './label.styled';

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

export const Label = (props: LabelProps) => <S.Label {...props} />;
